import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import WarrantyLogo from 'shared/components/WarrantyLogo/WarrantyLogo';
import WarrantyModal from 'desktop/components/WarrantyModal/WarrantyModal';
import GreenCheckBox from 'shared/assets/images/GreenCheckbox.png';
import s from './Warranty.css';

class Warranty extends React.Component {
  static propTypes = {
    warranty: PropTypes.shape().isRequired,
  };

  state = {
    showModal: false,
  };

  switchModal = () => this.setState({ showModal: !this.state.showModal });

  render() {
    const { warranty } = this.props;
    const { showModal } = this.state;

    return (
      <div className={s.root}>
        <div className={s.warrantyBlock}>
          <WarrantyLogo warranty={warranty} tooltipIcon={s.tooltipIcon} />
        </div>
        <div className={s.warrantyList}>
          {warranty.options.map(item => (
            <div className={s.option} key={item.title}>
              <img src={GreenCheckBox} alt="" className={s.checkBoxIcon} />
              <div className={s.optionTitles}>{item.title}</div>
            </div>
          ))}
        </div>
        <i className={`fa fa-info-circle ${s.topInfoIcon}`} onClick={this.switchModal} />
        <WarrantyModal showModal={showModal} switchModal={this.switchModal} warranty={warranty} />
      </div>
    );
  }
}

export default withStyles(s)(Warranty);



// WEBPACK FOOTER //
// ./src/desktop/routes/advert/components/Warranty/Warranty.js